var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ClientDetailsTheater extends Component {
    constructor(isDebugEnabled = false) {
        super('ClientDetailsTheater', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const listElement = $('.structure-members-list-theater');
            if (listElement.length > 0) {
                const firstnameInput = listElement.find('[name="relatedSet/str_membres_MBR/0/str_mbr_personnes_PERS::prenom"]');
                const lastnameInput = listElement.find('[name="relatedSet/str_membres_MBR/0/str_mbr_personnes_PERS::nom"]');
                const originalFirstname = firstnameInput.val();
                const originalLastname = firstnameInput.val();
                firstnameInput.on('keyup', () => {
                    if (firstnameInput.val() !== originalFirstname)
                        this.resetMemberIds();
                });
                lastnameInput.on('keyup', () => {
                    if (lastnameInput.val() !== originalLastname)
                        this.resetMemberIds();
                });
            }
            const specialMissionsSelect = $('#programmation_type-special_missions');
            if (specialMissionsSelect.length > 0) {
                if (specialMissionsSelect.get(0).checked)
                    $('#special-missions-container').removeClass('d-none');
                specialMissionsSelect.on('change', () => {
                    if (specialMissionsSelect.get(0).checked) {
                        $('#special-missions-container').removeClass('d-none');
                    }
                    else {
                        $('#special-missions-container').addClass('d-none');
                        $('#special-missions-container input').val('');
                    }
                });
            }
            this.manageArtisticDirectionAddMemberButtonVisibility();
            $('body').on('click', (event) => {
                setTimeout(() => {
                    this.manageArtisticDirectionAddMemberButtonVisibility();
                }, 100);
            });
            this.success();
        });
    }
    resetMemberIds() {
        const listElement = $('.structure-members-list-theater');
        listElement.find('[name="relatedSet/str_membres_MBR/0/str_membres_MBR::xId"]').val('');
        listElement.find('[name="relatedSet/str_membres_MBR/0/str_mbr_personnes_PERS::xId_personne"]').val('');
    }
    manageArtisticDirectionAddMemberButtonVisibility() {
        if ($('.structure-members-list-theater .member:not(.d-none)').length) {
            $('#button-search-personnes').addClass('d-none');
        }
        else {
            $('#button-search-personnes').removeClass('d-none');
        }
    }
}
